export const GET_APP_SWITCHER_URL = "GET_APP_SWITCHER_URL";
export const GET_APP_SWITCHER_URL_SUCCESS = "GET_APP_SWITCHER_URL_SUCCESS";
export const GET_APP_SWITCHER_URL_ERROR = "GET_APP_SWITCHER_URL_ERROR";
export const GET_APP_SWITCHER_URL_ERROR_MSG =
  "Sorry! Something went wrong. Please try again in a little bit.";
export const RESET_APP_SWITCHER_DATA = "RESET_APP_SWITCHER_DATA";
